'use strict';

const containedMapping = require('./containedMapping');

const mapTelecom = (phones, emails) => {
    const telecom = [];

    let phonePriority = 2;
    let emailPriority = 2;

    phones.forEach((phone) => {
        if (phone.number) {
            telecom.push({
                system: 'phone',
                value: phone.number,
                use: phone.phoneType,
                rank: phone.preferred ? 1 : phonePriority++
            });
        }
    });

    emails.forEach((email) => {
        if (email.address) {
            telecom.push({
                system: 'email',
                value: email.address,
                use: 'home',
                rank: email.preferred ? 1 : emailPriority++
            });
        }
    });

    return telecom;
};

const getMappingbyKey = (key) =>
    (containedMapping || []).find((map) => map.key === key);

const capitalize = (text) => `${text.charAt(0).toUpperCase()}${text.slice(1)}`;

const toBool = (value) => {
    if (value === '') {
        return null;
    }

    if (!value) {
        return false;
    }

    return value === 'yes' || value === true;
};

const toNumber = (value) => {
    if (isNaN(value)) {
        return 0;
    }

    return Number(value);
};

const transformValue = (value, type) => {
    switch (type) {
        case 'boolean':
            return toBool(value);
        case 'integer':
            return toNumber(value);
        default:
            return value;
    }
};

const mapContained = (fields) => {
    const items = [];

    Object.keys(fields).forEach((field) => {
        const keys = getMappingbyKey(field);
        if (keys) {
            const { text, type } = keys;
            const value = transformValue(fields[field], type);

            if (value !== null) {
                items.push({
                    text,
                    answer: [{ [`value${capitalize(type)}`]: value }]
                });
            }
        }
    });

    return items;
};

module.exports = (person, patientId) => {
    const {
        firstName,
        middleName,
        lastName,
        suffix,
        relationship,
        dob,
        address1,
        address2,
        city,
        state,
        zip,
        phones,
        emails,
        narus,
        id,
        notes,
        link
    } = person;

    const patientReference = {
        reference: `Patient/${patientId}`
    };

    const mappedRelatedPerson = {
        patient: patientReference,
        resourceType: 'RelatedPerson',
        name: [
            {
                use: 'usual',
                given: [firstName || ''],
                family: [lastName || ''],
                suffix: [suffix || '']
            }
        ],
        birthDate: dob, //moment.utc(dob).format('YYYY-MM-DD'),
        address: [
            {
                use: 'home',
                type: 'physical',
                line: [address1 || ''],
                postalCode: zip,
                country: 'USA',
                city,
                state
            }
        ],
        contained: [
            {
                resourceType: 'QuestionnaireResponse',
                status: 'completed',
                subject: patientReference,
                item: mapContained(narus || {})
            }
        ]
    };
    if (mapTelecom(phones, emails)) {
        mappedRelatedPerson.telecom = mapTelecom(phones, emails);
    }
    if (relationship) {
        mappedRelatedPerson.relationship = {
            coding: [
                {
                    code: relationship
                }
            ]
        };
    }

    if (middleName) {
        mappedRelatedPerson.name[0].given.push(middleName);
    }

    if (address2) {
        mappedRelatedPerson.address[0].line.push(address2);
    }

    if (id) {
        mappedRelatedPerson.id = id;
    }

    const extension = [];

    if (notes) {
        extension.push({
            url: 'http://narushealth.com/fhir/support-network-member-notes',
            valueString: notes
        });
    }
    if (link) {
        extension.push({
            url: 'http://narushealth.com/fhir/support-network-member-link',
            valueString: link
        });
    }
    if (extension.length > 0) {
        mappedRelatedPerson.extension = extension;
    }

    return mappedRelatedPerson;
};
